<template>
  <section class="custom-wrapper">
    <div class="row">
      <div class="col-md-12">
        <p>{{ notice }}</p>
        <div class="row">
          <div class="col-md-6">
            <z-input v-model="mergeCategory" label="Category" name="mergeCategory" :required="true" :inline="true" @keyup="changed" />
          </div>
          <div class="col-md-3">
            <input v-model="inactive" type="checkbox" class="custom-checkbox custom-inactive" @click="changed" />
            <span>Inactive?</span>
          </div>
        </div>
        <div v-if="!isAdd" class="row">
          <div class="col-md-12">
            <span class="custom-keywords">Lookup Keywords:</span>
            <matrix-basic-info-lookups :vehicle-make="vehicleMake" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZInput from '@/components/utilities/elements/Input.vue'
import MatrixBasicInfoLookups from './matrix-basic-info-lookups.vue'
export default {
  name: 'MatrixBasic',
  components: {
    ZInput,
    MatrixBasicInfoLookups
  },
  props: {
    value: Object
  },
  emits: ['changed'],
  computed: {
    ...mapState(adasmatrixStore, ['adasmatrix']),
    notice() {
      let _notice = ''
      if (this.value) {
        if (this.value.type === 'ADD') {
          _notice = "You're about to add a new ADAS merge category item.  This will be used to replace those coming from the decoder."
        } else {
          _notice = "You're editing this merge category item."
        }
      }
      return _notice
    },
    isAdd() {
      let _is = false
      if (this.value) {
        _is = this.value.type === 'ADD'
      }
      return _is
    },
    mergeCategory: {
      get() {
        let _data = ''
        if (this.adasmatrix !== undefined && this.adasmatrix !== null) {
          _data = this.adasmatrix.matrixItem
        }
        return _data
      },
      set(value) {
        this.setData({
          name: 'matrixItem',
          value: value
        })
      }
    },
    keywords: {
      get() {
        let _data = ''
        if (this.adasmatrix !== undefined && this.adasmatrix !== null) {
          _data = this.adasmatrix.keywords
        }
        return _data
      },
      set(value) {
        this.setData({
          name: 'keywords',
          value: value
        })
      }
    },
    sort: {
      get() {
        let _data = 0
        if (this.adasmatrix !== undefined && this.adasmatrix !== null) {
          _data = this.adasmatrix.sort
        }
        return _data
      },
      set(value) {
        this.setData({
          name: 'sort',
          value: value
        })
      }
    },
    inactive: {
      get() {
        let _data = false
        if (this.adasmatrix !== undefined && this.adasmatrix !== null) {
          _data = this.adasmatrix.isInactive
        }
        return _data
      },
      set(value) {
        this.setData({
          name: 'isInactive',
          value: value
        })
      }
    },
    vehicleMake() {
      let _id = null
      if (this.value) {
        _id = this.value.vehicleMake
      }
      return _id
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['setData']),
    changed() {
      this.$emit('changed')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
}
.custom-inactive {
  margin-top: 10px;
}
.custom-keywords {
  display: inline-block;
  margin-bottom: 0.5rem;
}
</style>
